import { render, staticRenderFns } from "./startup.vue?vue&type=template&id=233b1b6b&scoped=true&"
import script from "./startup.vue?vue&type=script&lang=js&"
export * from "./startup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b1b6b",
  null
  
)

export default component.exports